import * as React from 'react'
import { MoreHorizontal } from 'lucide-react'
import { Button } from './button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from './dropdown-menu'

export interface ActionMenuProps {
  children: React.ReactNode
  align?: 'start' | 'center' | 'end'
}

export function ActionMenu({ children, align = 'end' }: ActionMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          style={{
            boxShadow: 'rgba(0, 0, 0, 0.12) 0px 4px 16px 0px',
          }}
          className="  
            h-8 w-8
            rounded-full
            bg-slate-50
            text-slate-500
            inset-shadow-sm
            hover:text-primary
            hover:bg-primary/10
            transition-colors
            focus-visible:ring-1
            focus-visible:ring-primary  h-8 w-8
            rounded-full
            bg-white
            border border-slate-200
            text-slate-500
            hover:text-primary
            hover:bg-primary/10
            transition-colors
            focus-visible:ring-1
            focus-visible:ring-primary
          "
        >
          <span className="sr-only">Abrir menú de acciones</span>
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align={align}
        className="w-[180px] p-1.5 shadow-lg rounded-xl border-slate-200"
      >
        {children}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
